<template>
  <div class="flex j-center a-center">
    <div class="middle flex a-center j-between p-h-20">
      <img src="../assets/logo.png">
      <div class="flex a-center" style="display: none;">
        <a
          v-for="(item, key) in download" :key="key"
          class="color-blue download-btn c-p flex a-center j-center"
          @click="parseInt(key, 10) !== 2 && item.handler()"
          @mouseenter="parseInt(key, 10) === 2 && item.handler(true)"
          @mouseout="parseInt(key, 10) === 2 && item.handler(false)"
        >
          {{item.label}}
          <img v-if="parseInt(key, 10) !== 2" src="../assets/download.png"/>
          <transition name="fadeIn">
            <div v-show="parseInt(key, 10) === 2 && qrcodeVisible" class="qrcode-box">
              <img src="../assets/qrcode.png" class="w-full h-full"/>
            </div>
          </transition>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data () {
    return {
      download: {
        0: {
          label: 'PC版',
          handler: this.downloadPC
        },
        1: {
         label: 'Mac版',
          handler: this.downloadMac
        },
        2: {
          label: '手机版',
          handler: this.showQrcode
        }
      },
      qrcodeVisible: false
    }
  },
  methods: {
    downloadPC () {
      // add 百度统计
      _hmt.push(['_trackEvent', 'tingshuo-service', 'download', 'PC版'])
      // pc 安装包
      location.href = 'fltrp_ai_tingshuo_home_client_v1.0.exe'
    },
    downloadMac () {
      // add 百度统计
      _hmt.push(['_trackEvent', 'tingshuo-service', 'download', 'MAC版'])
      // mac 安装包
      location.href = 'mac.exe'
    },
    showQrcode (visible) {
      _hmt.push(['_trackEvent', 'tingshuo-service','download', '手机版'])
      this.qrcodeVisible = visible
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~/src/style/_var";

.fadeIn-enter-active, .fadeIn-leave-active {
  transition: opacity .5s;
}

.fadeIn-enter, .fadeIn-leave {
  opacity: 0;
}

.color-blue {
  color: #3299FF;
}

.download-btn {
  background: white;
  transition: all .4s ease;
  width: 128px;
  height: 35px;
  position: relative;
  .qrcode-box {
    width: 200px;
    height: 200px;
    position: absolute;
    box-shadow:0px 2px 2px 0px rgba(0,0,0,0.1);
    border:1px solid rgba(230,230,230,1);
    border-radius: 4px;
    bottom: -210px;
    z-index: 9999;
    background: white;
  }
  & > img {
    width: 13px !important;
    height: 12px;
    margin-left: 15px;
  }
  &:hover {
    background:rgba(50, 153, 255, 0.1032);
    border-radius: 4px;
  }
}

.middle {
  width: $app-width;
  & > img {
    width: 180px;
  }
}
@media (max-width: 767px) {
  .middle {
    width: 100%;
    & > img {
      width: auto;
      height: 28px;
    }
  }
}
</style>
